import { render, staticRenderFns } from "./ChangguanDdtcBlock.vue?vue&type=template&id=4f4bb4e4&scoped=true"
import script from "./ChangguanDdtcBlock.vue?vue&type=script&lang=js"
export * from "./ChangguanDdtcBlock.vue?vue&type=script&lang=js"
import style0 from "./ChangguanDdtcBlock.vue?vue&type=style&index=0&id=4f4bb4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4bb4e4",
  null
  
)

export default component.exports